import { PaymentTabsEnum } from '../../cart-bridger-pay/enums/payment-tabs-enum';
import PaypalIcon from '../../../../ui/svg/shopping-cart/paypal';
import AlipayIcon from '../../../../ui/svg/shopping-cart/alipay';
import ApplyPayIcon from '../../../../ui/svg/shopping-cart/apply-pay';
import CreditCardIcon from '../../../../ui/svg/shopping-cart/credit-card';

export const paymentTabSelectedStyles = {
    backgroundColor: '#ecf5ff',
    borderRadius: '4.1px',
    border: 'solid 0.7px #3452ff',
    color: '#3452ff',
};

export const getIconByType = (type: PaymentTabsEnum) => {
    switch (type) {
        case PaymentTabsEnum.PayPal: {
            return PaypalIcon;
        }
        case PaymentTabsEnum.AliPay: {
            return AlipayIcon;
        }
        case PaymentTabsEnum.ApplePay: {
            return ApplyPayIcon;
        }
        default: {
            return CreditCardIcon;
        }
    }
};

export const getEnabledPaymentTypes = (isChina: boolean, isApplePayEnabled: boolean): PaymentTabsEnum[] => {
    const types: PaymentTabsEnum[] = [];
    types.push(PaymentTabsEnum.CreditCard);

    // No PayPal and no ApplePay in China.
    if(!isChina) {
        types.push(PaymentTabsEnum.PayPal);

        if(isApplePayEnabled) {
            types.push(PaymentTabsEnum.ApplePay);
        }
    }

    // No subscription with AliPay....
    // const isSubscription = checkIsSubscription(cartData);

    return types;
};

export const getGoogleAnalyticsTitleByPaymentType = (type: PaymentTabsEnum): string => {
    switch (type) {
        case PaymentTabsEnum.PayPal: {
            return 'PayPal';
        }
        case PaymentTabsEnum.AliPay: {
            return 'AliPay';
        }
        case PaymentTabsEnum.ApplePay: {
            return 'ApplePay';
        }
        default: {
            return 'Credit Card';
        }
    }
};